import { render, staticRenderFns } from "./AnLink.vue?vue&type=template&id=a976dfb8&scoped=true&"
import script from "./AnLink.vue?vue&type=script&lang=ts&"
export * from "./AnLink.vue?vue&type=script&lang=ts&"
import style0 from "./AnLink.vue?vue&type=style&index=0&id=a976dfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a976dfb8",
  null
  
)

export default component.exports